<template>
<v-app id="registration-page">
      <cookie-law theme="blood-orange--rounded" 
                  buttonText="ACCETTO!">
                  <div slot="message">
                    QuickBe Utilizza cookie tecnici e di terze parti per fornirti il migliore servizio possible, 
                    puoi vedere in dettaglio cosa usiamo e come disabilitarlo da qui:
                    <router-link class="q-orange"
                      :title="getString('Uso dei cookies')"
                      to="/legal/cookie">Info Cookie
                    </router-link>
            </div>
      </cookie-law>
    <v-content style="margin-bottom:150px">
        <header-p></header-p>
        <section id="registerForm" style="margin-top:30px">
            <v-layout column lg8 md10 sd12 xs12 align-center justify-center>
                <v-container>
                    <header id="top" style="margin:auto;max-width:900px">
                        <div>
                            <div class="row">
                                <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12 full-height">
                                    <h1>Cookie e dati locali Policy</h1>

                                    <h4>Ai sensi dell’art. 13 del D.Lgs 196/03 “Codice in materia di protezione dei dati personali”, per coloro che utilizzano con i servizi web di QuickBe dall'indirizzo:</h4>

                                    <b>www.quickbe.app</b>

                                    <p>L'utilizzo dei cookie permette la navigazione, la semplificazione di quest'ultima ed il supporto tecnico tale da poter far fruire i contenuti</p>

                                    <h3>Cosa sono i cookie</h3>

                                    <p>I cookie sono piccoli file di testo inviati dal sito al terminale dell’interessato (solitamente al browser), dove vengono memorizzati per essere poi ritrasmessi al sito alla successiva visita del medesimo utente. Un
                                        cookie non può richiamare nessun altro dato dal disco fisso dell’utente né trasmettere virus informatici o acquisire indirizzi email. Ogni cookie è unico per il web browser dell’utente. Alcune delle funzioni dei
                                        cookie possono essere demandate ad altre tecnologie. Nel presente documento con il termine ‘cookie’ si vuol far riferimento sia ai cookie, propriamente detti, sia a tutte le tecnologie similari.</p>

                                    <h3>Sorgente Cookie</h3>

                                    <p>
                                        I cookie possono essere di prima o di terza parte, dove per “prima parte” si intendono i cookie che riportano come dominio il sito, mentre per “terza parte” si intendono i cookie che sono relativi a domini esterni.
                                    </p>

                                    <p>
                                        I cookie di terza parte sono necessariamente installati da un soggetto esterno, sempre definito come “terza parte”, non gestito dal sito. Tali soggetti possono eventualmente installare anche cookie di prima parte, salvando sul dominio del sito i propri
                                        cookie.
                                    </p>

                                    <h2>Tipologia del cookie</h2>

                                    <h3>Cookie tecnici</h3>
                                    <p>I <b>cookie tecnici</b> sono quelli utilizzati al solo fine di “effettuare la trasmissione di una comunicazione su una rete di comunicazione elettronica, o nella misura strettamente necessaria al fornitore di un servizio
                                        della società dell’informazione esplicitamente richiesto dall’abbonato o dall’utente a erogare tale servizio”.</p>

                                    <p>Essi non vengono utilizzati per scopi ulteriori e sono normalmente installati direttamente dal titolare o gestore del sito web. Possono essere suddivisi in:</p>
                                    <ul>
                                        <li><b>Cookie</b> di navigazione o di sessione, che garantiscono la normale navigazione e fruizione del sito web (permettendo, ad esempio, di realizzare un acquisto o autenticarsi per accedere ad aree riservate); essi
                                            sono di fatto necessari per il corretto funzionamento del sito</li>
                                        <li><b>Cookie</b> analytics, assimilati ai cookie tecnici laddove utilizzati direttamente dal gestore del sito per raccogliere informazioni, in forma aggregata, sul numero degli utenti e su come questi visitano il sito
                                            stesso, al fine di migliorare le performance del sito</li>
                                        <li><b>Cookie</b> di funzionalità, che permettono all’utente la navigazione in funzione di una serie di criteri selezionati (ad esempio, la lingua, i prodotti selezionati per l’acquisto) al fine di migliorare il servizio
                                            reso allo stesso. Per l’installazione di tali cookie non è richiesto il preventivo consenso degli utenti (più informazioni nel paragrafo Gestione dei cookie in basso)</li>
                                    </ul>
                                    <h3>Cookie di profilazione</h3>

                                    <p>I cookie di profilazione sono volti a creare profili relativi all’utente e vengono utilizzati al fine di inviare messaggi pubblicitari in linea con le preferenze manifestate dallo stesso nell’ambito della navigazione
                                        in rete.</p>

                                    <p>Per l’utilizzo dei cookie di profilazione è richiesto il consenso dell’interessato. Secondo il provvedimento (più informazioni nel paragrafo Gestione dei cookie in basso) l’utente può autorizzare o negare il consenso
                                        all’installazione dei cookie attraverso le opzioni fornite nella sezione “Gestione dei cookie”.</p>

                                    <p>In caso di cookie di terze parti, il sito non ha un controllo diretto dei singoli cookie e non può controllarli (non può né installarli direttamente né cancellarli). Puoi comunque gestire questi cookie attraverso le
                                        impostazioni del browser (segui le istruzioni riportate più avanti), o i siti indicati nella sezione “Gestione dei cookie”.</p>

                                    <h3>Cookie usati da quickbe.app</h3>

                                    <p>Tali Cookie sono necessari per il corretto funzionamento del sito, ove, se disattivati con le guide fornite in seguito, non è garantito il funzionamento.</p>

                                    <table class="c-table">
                                        <thead>
                                            <tr>
                                                <th colspan="2">Elenco cookie utilizzati da quickbe.app</th>
                                            </tr>
                                            <tr>
                                                <th>Dominio</th>
                                                <th>Nome</th>
                                                <th>Descrizione</th>
                                                <th>Tipo</th>
                                                <th>Indispensabile</th>
                                                <th>Policy</th>
                                            </tr>
                                        </thead>
                                        <tr>
                                            <td>quickbe.app</td>
                                            <td>lang</td>
                                            <td>Indica la lingua corrente</td>
                                            <td>Cookie</td>
                                            <td>No</td>
                                            <td>N/A</td>
                                        </tr>
                                        <tr>
                                            <td>quickbe.app</td>
                                            <td>lang</td>
                                            <td>Indica la lingua corrente</td>
                                            <td>LocalStorage</td>
                                            <td>No</td>
                                            <td>N/A</td>
                                        </tr>
                                        <tr>
                                            <td>quickbe.app</td>
                                            <td>_rccarriage_5t_puorcnfam</td>
                                            <td>Indica la sessione corrente dell'utente</td>
                                            <td>LocalStorage</td>
                                            <td>Sì</td>
                                            <td>N/A</td>
                                        </tr>
                                        <tr>
                                            <td>quickbe.app</td>
                                            <td>p_data</td>
                                            <td>Permette di ricevere le notifiche sul calendario (solo esercenti)</td>
                                            <td>LocalStorage</td>
                                            <td>Sì</td>
                                            <td>N/A</td>
                                        </tr>
                                        <tr>
                                            <td>quickbe.app</td>
                                            <td>__cfduid</td>
                                            <td>Permette di tutelare il funzionamento del sito tramite il servizio cloudflare</td>
                                            <td>Cookie</td>
                                            <td>Sì</td>
                                            <td><a href="https://www.cloudflare.com/it-it/privacypolicy/">CloudFlare Privacy</a></td>
                                        </tr>
                                         <tr>
                                            <td>facebook.com</td>
                                            <td>Tutti associati al dominio</td>
                                            <td>Permette di profilare le visite, le registrazioni ed alcune azioni. Permette di comunicare con la pagina facebook direttamente dalla Home Page</td>
                                            <td>Cookie di terze parti</td>
                                            <td>No</td>
                                            <td><a href="https://www.facebook.com/policies/cookies/">Facebook Policy</a></td>
                                        </tr>
                                          <tr>
                                            <td>google.com</td>
                                            <td>Tutti associati al dominio</td>
                                            <td>Permettono di ottenere statistiche sull'uso del sito e dell'usufruizione dei servizi Google.</td>
                                            <td>Cookie di terze parti</td>
                                            <td>No</td>
                                            <td><a href="https://policies.google.com/technologies/cookies?hl=it">Google Policy</a></td>
                                        </tr>                                        
                                    </table>
                                    <br/>
                                    <h3>Rifiuto consenso Cookie</h3>
                                    <p>E' possibile rifiutare il consenso dell'utilizzo dei Cookie su QuickBe.app, con le relative conseguenze:</p>
                                    <h4>Cookie tecnici o di funzionalità</h4>
                                    <p>Rifiutando l'utilizzo dei Cookie di funzionalità/tecninci si potrebbe compromettere se non rendere impossibile usare la piattaforma.</p>
                                    <h4>Cookie di terze parti, statistiche o profilazione</h4>
                                    <p>Disabilitare i cookie terzi può compromettere l'utilizzo di alcune funzionalità fornite dai terzi (esempio chat messenger) ma non comprometterà l'uso del sito.</p>
                                    <h5>Come rifiutare</h5>
                                    <ul>
                                        <li>Disabilitando i Cookie sul sito (vedi istruzioni più avanti)</li>
                                        <li>Abilitando la funzionalità DTN (Do Not Track) nel browser dalle impostazioni di Privacy e Sicurezza</li>
                                    </ul>
                                    <br/>
                                    <h3>Gestione dei Cookie</h3>

                                    <p>L’Utente ha la facoltà in qualsiasi momento di esercitare i diritti riconosciuti dall’art. 7 del D.Lgs. 196/2003 ed, in particolare, tra gli altri, di ottenere copia dei dati trattati, il loro aggiornamento, la loro
                                        origine, la finalità e la modalità del trattamento, la loro rettifica o integrazione, la loro cancellazione, la trasformazione in forma anonima o il blocco per i trattamenti in violazione di legge e di opporsi per
                                        motivi legittimi al trattamento come specificato sui <a href="/legal/pp"> termini di privacy policy </a></p>

                                    <p>Se è già stato dato il consenso ma si vogliono cambiare le autorizzazioni dei cookie, bisogna cancellarli attraverso il browser.</p>

                                    <h2>Disabilitare o Cancellare i Cookie</h2>

                                    <h3>Chrome</h3>

                                    <ul>

                                        <li>
                                            Eseguire il Browser Chrome
                                        </li>
                                        <li>
                                            Fare click sul menù presente nella barra degli strumenti del browser a fianco della finestra di inserimento url per la navigazione
                                        </li>
                                        <li>
                                            Selezionare Impostazioni
                                        </li>
                                        <li>
                                            Fare clic su Mostra Impostazioni Avanzate
                                        </li>
                                        <li>
                                            Nella sezione “Privacy” fare clic su bottone “Impostazioni contenuti“
                                        </li>
                                        <li>
                                            Nella sezione “Cookie” è possibile modificare le seguenti impostazioni relative ai cookie:
                                        </li>
                                        <li>
                                            Consentire il salvataggio dei dati in locale
                                        </li>
                                        <li>
                                            Modificare i dati locali solo fino alla chiusura del browser
                                        </li>
                                        <li>
                                            Impedire ai siti di impostare i cookie
                                        </li>
                                        <li>
                                            Bloccare i cookie di terze parti e i dati dei siti
                                        </li>
                                        <li>
                                            Gestire le eccezioni per alcuni siti internet
                                        </li>
                                        <li>
                                            Eliminare uno o tutti i cookie
                                        </li>
                                    </ul>
                                    <p>Per maggiori informazioni visita la pagina dedicata.</p>

                                    <h3>Mozilla Firefox</h3>
                                    <ul>
                                        <li>
                                            Eseguire il Browser Mozilla Firefox
                                        </li>
                                        <li>
                                            Fare click sul menù presente nella barra degli strumenti del browser a fianco della finestra di inserimento url per la navigazione
                                        </li>
                                        <li>
                                            Selezionare Opzioni
                                        </li>
                                        <li>
                                            Selezionare il pannello Privacy
                                        </li>
                                        <li>
                                            Fare clic su Mostra Impostazioni Avanzate
                                        </li>
                                        <li>
                                            Nella sezione “Privacy” fare clic su bottone “Impostazioni contenuti“
                                        </li>
                                        <li>
                                            Nella sezione “Tracciamento” è possibile modificare le seguenti impostazioni relative ai cookie:
                                        </li>
                                        <li>
                                            Richiedi ai siti di non effettuare alcun tracciamento
                                        </li>
                                        <li>
                                            Comunica ai siti la disponibilità ad essere tracciato
                                        </li>
                                        <li>
                                            Non comunicare alcuna preferenza relativa al tracciamento dei dati personali
                                        </li>
                                        <li>
                                            Dalla sezione “Cronologia” è possibile:
                                        </li>
                                        <li>
                                            Abilitando “Utilizza impostazioni personalizzate” selezionare di accettare i cookie di terze parti (sempre, dai siti più visitato o mai) e di conservarli per un periodo determinato (fino alla loro scadenza, alla chiusura di Firefox o di chiedere ogni
                                            volta)
                                        </li>
                                        <li>
                                            Rimuovere i singoli cookie immagazzinati.
                                        </li>
                                    </ul>
                                    <p>Per maggiori informazioni visita la pagina dedicata.</p>
                                    <h3>Microsoft Edge</h3>
                                    <ul>
                                        <li>Eseguire il Browser Edge</li>
                                        <li>Fare click sul pulsante con i tre puntini e scegli Impostazioni</li>
                                        <li>Fare click sul bottone "Impostazioni avanzate"</li>
                                        <li>Scorri e seleziona "Bloccare tutti i cookie" nella sezione Cookie</li>
                                    </ul>
                                    <p>Per maggiori informazioni visita la pagina dedicata.</p>
                                    <h3>Safari 6</h3>
                                    <ul>
                                        <li>Eseguire il Browser Safari</li>
                                        <li>Fare click su Safari, selezionare Preferenze e premere su Privacy</li>
                                        <li>Nella sezione Blocca Cookie specificare come Safari deve accettare i cookie dai siti internet.</li>
                                        <li>Per visionare quali siti hanno immagazzinato i cookie cliccare su Dettagli</li>
                                    </ul>
                                    <p>Per maggiori informazioni visita la pagina dedicata.</p>
                                </div>
                            </div>
                        </div>
                    </header>
                </v-container>
            </v-layout>
              <v-layout column>
                <v-flex xs12 sm4 class="my-3">
                    <div class="text-xs-center">

                        <v-container>
                            <v-btn class="q-orange" @click="$router.push({path:'/'})">{{getString('Torna a QuickBe')}}</v-btn>
                        </v-container>
                    </div>
                </v-flex>
            </v-layout>
        </section>
    </v-content>
    <v-footer dark height="auto" class=".footer">
        <v-card class="flex" flat tile>
            <v-card-title class="q-orange-bk">
                <strong class="subheading">{{getString("Seguici sui social!")}}</strong>
                <v-spacer></v-spacer>
                <v-btn v-for="icon in icons" :key="icon.ic" class="mx-3" dark icon @click="navigate(icon.url)">
                    <v-icon size="24px">{{ icon.ic }}</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="grey darken-3 justify-center" style="text-align:center">
                &copy;{{(new Date()).getFullYear()}} — &nbsp;<strong>Dew Studio</strong> &nbsp; — &nbsp;
                <a href="https://plaza.quickbe.app">{{getString('QuickBe Plaza')}}</a>&nbsp; — &nbsp;
                <router-link to="/legal/tec">{{getString('Trattamento dati')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/legal/cookie">{{('Cookie Policy')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/legal/eula">{{('Termini e condizioni')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/admin/login">{{getString('Portale')}}</router-link>
            </v-card-text>
        </v-card>
    </v-footer>
</v-app>
</template>

<script>
import HeaderP from './Header'
import CookieLaw from "vue-cookie-law";
export default {
  name: 'CookieP',
  components: {
        HeaderP,
        CookieLaw
    },
  data: () => {
    return {
      icons: [
        {
          ic: 'fab fa-facebook',
          url: 'https://www.facebook.com/QuickBeApp/'
        },
        {
          ic: 'fab fa-instagram',
          url: 'https://www.instagram.com/quickbeapp/'
        }
      ]
    }
  },
  methods: {
    navigate: function(url) {
      window.open(url)
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key)
      return page
    }
  }
}
</script>

<style scoped>
h2,
h3,
h4 {
  color: #d5725b;
}
.c-table td {
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: solid thin #bbb;
  padding-bottom:5px;
}

</style>



// WEBPACK FOOTER //
// src/components/frontend/CookieP.vue